export async function fetchBureau() {
    const empty = {presentation: '', membres: []};
    const res = await fetch('/bureau/bureau.json', {cache: 'no-store'}); // no-store pour dev, retirez si cache voulu
    if (!res.ok) {
        throw new Error(`Fetch bureau failed: ${res.status}`);
    }
    const data = await res.json();
    return data.bureau || [];
    // data.bureau devrait être un objet { presentation, membres }
    return data && data.bureau ? data.bureau : empty;
    return [];
}
